module.exports = __webpack_public_path__ + "static/media/learn-python.0185af45.svg";